<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customParentData="customParentData"
    :customCreateAction="customCreateAction"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/license_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    customCreateAction: (modelData) => {
      if (modelData.range_type === "exclusive") {
        modelData.factories = []
      }
      if(modelData.range_type === "general") {
        modelData.exclusive_factories = null
      }
      if (modelData.last_version.recommend_notify_period === null 
      || modelData.last_version.recommend_notify_period === "") {
        modelData.last_version.recommend_notify_period = 0
      }
      if (modelData.last_version.statitory_extension_period === null
      || modelData.last_version.statitory_extension_period === "") {
        modelData.last_version.statitory_extension_period = 0
      }
      if (modelData.last_version.training_hours === null
      || modelData.last_version.training_hours === "") {
        modelData.last_version.training_hours = 0
      }
      modelData.last_version.version_status = 1;
    },
    customParentData: (parentData) => {
      return {
        area: parentData.area,
      };
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "license_type",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["status"],
            },
          ],
        },
      ],
    },
  }),
};
</script>